// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"20c0760c","787":"154b7f1e","859":"c97f3d72"}[chunkId] + ".chunk.js";
};